import { render } from "./App.vue?vue&type=template&id=0a8ab368"
const script = {}

import "./App.vue?vue&type=style&index=0&id=0a8ab368&lang=scss"

import exportComponent from "/Users/eduardopassos/Documents/Dev/blat/subsextract/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__